export default __webpack_public_path__ + "static/media/planet-remix.ab2fcf72.svg";